export default __webpack_public_path__ + "e0a4ea2.png";